<script>
  export let data;
  let result = [];
  let focus = false;
  $: attributes = { name: data.key, multiple: data.type === 'many' };
</script>

<div>
  <label class="input-file" data-focus={focus || !!result.length}>
    {#each result as file, i}
      <button type="button" on:click={() => (result = result.filter((_, j) => j !== i))}> {file} <span /></button>
    {/each}
    <input
      on:blur={() => (focus = false)}
      on:focus={() => (focus = true)}
      on:change={e => {
        const { files } = e.target;
        result = [...files].map(f =>
          f.name.length > 25 ? f.name.slice(0, 30) + '...' + f.name.slice(f.name.indexOf('.')) : f.name,
        );
      }}
      type="file"
      {...attributes} />
  </label>

  <span>
    {data.placeholder}
  </span>

  {#if data.required}
    <strong>*</strong>
  {/if}
</div>

<style lang="scss">
  input {
    display: none;
  }

  label {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 5px;
    align-items: flex-start;
    justify-content: flex-start;
    background: #f6f7f8 !important;
    transform: scale(1) !important;
    cursor: pointer;
  }

  label > button {
    z-index: 2;
    display: inline-flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    padding: 5px 15px;
    color: #fff;
    background: #22eaac;
    border-radius: 5px;

    > span {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15px;
      height: 15px;

      &::after,
      &::before {
        position: absolute;
        width: 4px;
        height: 100%;
        background: #fff;
        content: '';
      }

      &::after {
        transform: rotate(45deg);
      }

      &::before {
        transform: rotate(-45deg);
      }
    }
  }

  div > span {
    display: inline-flex;
    align-items: center;
    color: #2c333c !important;
    background: #f6f7f8 !important;
  }

  div > span::before {
    display: block;
    min-width: 24px;
    min-height: 24px;
    margin-right: 10px;
    background-image: url('https://admin.uberi.pro/uploads/paperclip_4cb3451189.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    content: '';
  }
</style>
